module.exports = __webpack_public_path__ + "static/media/snyk.393e7c36.png";